import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Input, OnDestroy, OnInit } from '@angular/core';
import { IFacet } from '@ncg/data';
import { SettingsService } from '../../core/settings.service';
import { Subject } from 'rxjs';
import { map, takeUntil } from 'rxjs/operators';
import SwiperCore, { Navigation, SwiperOptions } from 'swiper';
import { FeatureDetectionService } from '../../core/feature-detection.service';
import { tileAnimation } from '../../utils/animations/filter.animation';

SwiperCore.use([Navigation]);

@Component({
    selector: 'ncg-filter-tiles',
    template: `
        <div class="filter-tiles container" ncgInViewport (intersectOutput)="intersecting($event)">
            <ng-container *ngIf="makers?.length">
                <swiper
                    class="filter-tiles-swiper filter-tiles__container swiper-button-container--secondary"
                    [slidesPerView]="'auto'"
                    [slideClass]="'swiper-slide'"
                    [navigation]="true"
                    [slidesPerGroup]="1"
                    [breakpoints]="breakpoints"
                    [@tileList]="animationState"
                >
                    <ng-template swiperSlide *ngFor="let make of makers">
                        <a class="filter-tile" [routerLink]="[linkToUsedCars]" [queryParams]="{ 'make.keyword': make.key }">
                            <div class="filter-tile__logo">
                                <ncg-logos [key]="make.key" iconWidthSm="55" iconWidth="60" iconWidthLg="62" iconWidthXl="70"></ncg-logos>
                            </div>
                            <div class="filter-tile__content">
                                <ng-container *ngIf="make.key || '' | lowercase as key">
                                    <div *ngIf="!isBag || key === 'bmw' || key === 'mini'" class="filter-tile__title">{{ make.key }}</div>
                                </ng-container>
                                <div class="filter-tile__description">
                                    {{ 'filter_spot.filter_tile_see_more' | translate: { amount: make.count } }}
                                </div>
                            </div>
                        </a>
                    </ng-template>
                </swiper>
            </ng-container>
        </div>
    `,
    changeDetection: ChangeDetectionStrategy.OnPush,
    animations: [tileAnimation],
})
export class FilterTilesComponent implements OnInit, OnDestroy {
    private readonly unsubscribe = new Subject<void>();

    private makesLoaded = false;
    private intersectData?: { isIntersecting?: boolean; notSupported?: boolean };

    public isBag: boolean = false;
    public makers?: IFacet[] = [];
    public animationState = 'make';
    public breakpoints: {
        [width: number]: SwiperOptions;
        [ratio: string]: SwiperOptions;
    } = {
        1000: {
            slidesPerGroup: 3,
        },
        1300: {
            slidesPerGroup: 4,
        },
    };

    @Input()
    public makersArr?: IFacet[];

    @Input()
    public linkToUsedCars = '';

    constructor(
        private readonly cd: ChangeDetectorRef,
        private readonly settingsService: SettingsService,
        private readonly featureDetectionService: FeatureDetectionService
    ) {}

    public ngOnDestroy() {
        this.unsubscribe.next();
        this.unsubscribe.complete();
    }

    public ngOnInit(): void {
        if (this.featureDetectionService.isFirstPageLoad) {
            this.animationState = 'noAnimation';
        }
        this.getLogoSetting();
    }

    public intersecting(data?: { isIntersecting?: boolean; notSupported?: boolean }) {
        this.intersectData = data;

        if (!this.makesLoaded && this.intersectData?.isIntersecting) {
            this.makers = this.makersArr;
            this.animationState = 'make';
            this.cd.markForCheck();
            this.makesLoaded = true;
        }
    }
    private getLogoSetting() {
        this.settingsService
            .get()
            .pipe(
                map((s) => s.brandId === 'bag'),
                takeUntil(this.unsubscribe)
            )
            .subscribe((allowLogos) => {
                this.isBag = allowLogos;
                this.cd.markForCheck();
            });
    }
}
